import React from 'react';

interface PinIconProps {
  color?: string;
  size?: number;
}

const PinIcon: React.FC<PinIconProps> = ({ color = '#2B5CDD', size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.3333 11.1L17 12.9V14.7H12.8333V20.1L12 21L11.1667 20.1V14.7H7V12.9L8.66667 11.1V4.8H7.83333V3H16.1667V4.8H15.3333V11.1Z'
        fill={color}
      />
    </svg>
  );
};

export default PinIcon;
